import React, { memo, useCallback } from "react";
import { Button } from "antd";
import { EditOutlined } from "@ant-design/icons";

const GUTTER_WIDTH = 28;

const stopEvent = (e) => {
  e.preventDefault();
  e.stopPropagation();
};

const LabelWithEditAction = ({ text, onEdit }) => {
  const handleEdit = useCallback(
    (e) => {
      stopEvent(e);
      onEdit?.();
    },
    [onEdit]
  );

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      <span
        aria-hidden
        style={{
          width: GUTTER_WIDTH,
          marginLeft: -GUTTER_WIDTH,
          display: "flex",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Button
          size="small"
          type="default"
          icon={<EditOutlined />}
          onClick={handleEdit}
          onMouseDown={stopEvent}
          aria-label={`Edit ${text}`}
        />
      </span>

      <span>{text}</span>
    </span>
  );
};

export default memo(LabelWithEditAction);
